var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailResendOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4462_58138)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.3897 9.59277C8.70398 9.59277 8.14294 10.1538 8.14294 10.8395V18.32C8.14294 19.0058 8.70398 19.5668 9.3897 19.5668H15.9352C15.7656 19.1704 15.6604 18.7496 15.6235 18.32H9.3897V12.0863L14.3767 15.2032L19.3637 12.0863V13.9564C19.4676 13.9527 19.5715 13.9527 19.6754 13.9564C19.9904 13.9573 20.3042 13.995 20.6105 14.0686V10.8395C20.6105 10.1538 20.0494 9.59277 19.3637 9.59277H9.3897ZM9.3897 10.8395H19.3637L14.3767 13.9564L9.3897 10.8395ZM19.3637 14.5798L17.9611 15.9824L19.3637 17.385V16.4499C19.777 16.4499 20.1734 16.6141 20.4657 16.9064C20.758 17.1986 20.9222 17.595 20.9222 18.0084C20.9222 18.2577 20.8661 18.4946 20.7601 18.7065L21.4396 19.386C21.7014 18.9933 21.8572 18.5195 21.8572 18.0084C21.8572 16.6307 20.7414 15.5149 19.3637 15.5149V14.5798ZM17.2879 16.6307C17.0261 17.0234 16.8702 17.4972 16.8702 18.0084C16.8702 19.386 17.9861 20.5019 19.3637 20.5019V21.4369L20.7663 20.0343L19.3637 18.6317V19.5668C18.9504 19.5668 18.554 19.4026 18.2617 19.1103C17.9695 18.8181 17.8053 18.4217 17.8053 18.0084C17.8053 17.759 17.8614 17.5221 17.9674 17.3102L17.2879 16.6307Z",
    fill: "#4A5565"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4462_58138",
    x: 0.6,
    y: 0.6,
    width: 28.8,
    height: 28.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4462_58138"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4462_58138",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailResendOutline);
export default __webpack_public_path__ + "static/media/email-resend-outline.48adbbf3b1e9d7e669a0c12bdb957c87.svg";
export { ForwardRef as ReactComponent };